import { Link } from 'react-router-dom'
import { css } from './css'
import logoLeao from '../../assets/logo-leao.png'

const LINK = css('text-decoration: none; color: #A8B0C3; font-size: 14px;')
const TITULO = css('color: #FFFFFF; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px;')

export function Footer() {
  return (
    <div style={css('width: 100%; box-sizing: border-box; background: #070C16; border-top: 1px solid rgba(255,255,255,0.08); padding: 48px 32px 28px;')}>
      <div style={css('max-width: 1200px; margin: 0 auto; display: flex; flex-direction: column; gap: 32px;')}>
        <div style={css('display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 24px;')}>
          <div style={css('display: flex; flex-direction: column; gap: 10px;')}>
            <div style={css('display: flex; align-items: center; gap: 8px; margin-bottom: 6px;')}>
              <img src={logoLeao} alt="" style={css('height: 24px; width: auto;')} />
              <span style={css('color: #FFFFFF; font-size: 15px; font-weight: 800;')}>WALLEON</span>
            </div>
            <p style={css('margin: 0; font-size: 13px; color: #6B7691; line-height: 1.6; max-width: 220px;')}>Organize suas finanças pessoais em um só lugar, sozinho ou com quem você confia.</p>
          </div>
          <div style={css('display: flex; flex-direction: column; gap: 12px;')}>
            <span style={TITULO}>Produto</span>
            <Link to="/#produto" style={LINK}>Recursos</Link>
            <Link to="/precos" style={LINK}>Preços</Link>
            <Link to="/conectar-bancos" style={LINK}>Conectar bancos</Link>
            <Link to="/baixar-app" style={LINK}>Aplicativo</Link>
            <Link to="/duvidas" style={LINK}>Dúvidas e tutoriais</Link>
            <Link to="/contato" style={LINK}>Fale conosco</Link>
          </div>
          <div style={css('display: flex; flex-direction: column; gap: 12px;')}>
            <span style={TITULO}>Legal</span>
            <Link to="/cookies" style={LINK}>Política de cookies</Link>
            <Link to="/conectar-bancos#legal" style={LINK}>Aviso sobre a Pluggy</Link>
          </div>
          <div style={css('display: flex; flex-direction: column; gap: 12px;')}>
            <span style={TITULO}>Conta</span>
            <Link to="/" style={LINK}>Entrar</Link>
            <Link to="/criar-conta" style={LINK}>Criar conta grátis</Link>
          </div>
        </div>
        <div style={css('border-top: 1px solid rgba(255,255,255,0.08); padding-top: 20px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px;')}>
          <span style={css('font-size: 12px; color: #4E5872;')}>© {new Date().getFullYear()} Walleon. Todos os direitos reservados.</span>
          <span style={css('font-size: 12px; color: #4E5872;')}>A Walleon não é uma instituição financeira. Dados de contas conectadas via Open Finance são processados pela Pluggy Brasil Instituição de Pagamento Ltda.</span>
        </div>
      </div>
    </div>
  )
}
